import { useTranslation } from "react-i18next";
import Style from './style';
import { itemsConfig } from "./config";
import AnalysisWidget from "../../../../../../Analysis/widget";
import { formatClassname } from "datastake-daf/src/helpers/ClassesHelper";

export default function Overview({ data = {}, options = {} }) {
  const { t } = useTranslation();
  const config = itemsConfig(t);

  return (
    <AnalysisWidget
      title={t('Overview')}
      className="with-border-header">
      <Style>
        {config.map((item, i) => (
          <div className={formatClassname(['item flex-1', item.className])} key={`item-${i}`}>
            <label>{item.label}</label>
            <div className="item-value">
              {item.render(data, options)}
            </div>
          </div>
        ))}
      </Style>
    </AnalysisWidget>
  )
}
